import { Route, Routes } from "react-router-dom";
import { useAppSelector } from "src/app/hooks";
import { selectUser } from "src/appRedux/reducers/userReducer";
import VaiTro from "src/routes/HeThong/VaiTro/VaiTro";
import { checkAuth } from "src/util/Commom";
import Error401 from "./Error401";
import ChucVu from "./HeThong/ChucVu/ChucVu";
import ChucVuForm from "./HeThong/ChucVu/ChucVuForm";
import NguoiDung from "./HeThong/NguoiDung/NguoiDung";
import NguoiDungForm from "./HeThong/NguoiDung/NguoiDungForm";
import PhongBan from "./HeThong/PhongBanTree/PhongBan";
import PhongBanForm from "./HeThong/PhongBanTree/PhongBanForm";
import Quyen from "./HeThong/Quyen/Quyen";
import QuyenForm from "./HeThong/Quyen/QuyenForm";
import VaiTroForm from "./HeThong/VaiTro/VaiTroForm";
import Home from "./UserInfo/Home";
import HomeLayout from "src/page/Public/Layout/Home";
import HoSo from "./UserInfo/HoSo";
import NhomTaiLieu from "./DanhMuc/NhomTaiLieu/NhomTaiLieu";
import NhomTaiLieuForm from "./DanhMuc/NhomTaiLieu/NhomTaiLieuForm";
import LoaiTaiLieu from "./DanhMuc/LoaiTaiLieu/LoaiTaiLieu";
import LoaiTaiLieuForm from "./DanhMuc/LoaiTaiLieu/LoaiTaiLieuForm";
import ThoiHanLuuTru from "./DanhMuc/ThoiHanLuuTru/ThoiHanLuuTru";
import ThoiHanLuuTruForm from "./DanhMuc/ThoiHanLuuTru/ThoiHanLuuTruForm";
import PhanQuyenNguoiDung from "./DanhMuc/PhanQuyenNguoiDung/PhanQuyenNguoiDung";
import PhanQuyenNguoiDungForm from "./DanhMuc/PhanQuyenNguoiDung/PhanQuyenNguoiDungForm";
import PhongBanTableForm from "./HeThong/PhongBanTable/PhongBanTableForm";
import PhongBanTable from "./HeThong/PhongBanTable/PhongBanTable";
import DanhSachTuLieu from "./DanhSachTuLieu/DanhSachTuLieu";
import DanhSachTuLieuForm from "./DanhSachTuLieu/DanhSachTuLieuForm";
import DanhSachVideo from "./DanhSachVideo/DanhSachVideo";
import DanhSachVideoForm from "./DanhSachVideo/DanhSachVideoForm";
import DanhSachHinhAnh from "./DanhSachHinhAnh/DanhSachHinhAnh";
import DanhSachHinhAnhForm from "./DanhSachHinhAnh/DanhSachHinhAnhForm";
import ThongTinHinhAnhDetail from "./DanhSachHinhAnh/ThongTinHinhAnhDetail";
import ThongTinTuLieuDetail from "./DanhSachTuLieu/ThongTinTuLieuDetail";
import ThongTinVideoDetail from "./DanhSachVideo/ThongTinVideoDetail";
import TraLoiGopYForm from "./HeThong/TraLoiGopY/TraLoiGopYForm";
import DanhSachGopY from "./HeThong/TraLoiGopY/DanhSachGopY";
import ThongKeTheoNguoiNhap from "./ThongKe/ThongKeTheoNguoiNhap/ThongKeTheoNguoiNhap";
import ThongKeTongHop from "./ThongKe/ThongKeTongHop/ThongKeTongHop";
import ChiTietTheoNguoiNhap from "./ThongKe/ThongKeTheoNguoiNhap/ChiTietTheoNguoiNhap";
import ChiTietTongHop from "./ThongKe/ThongKeTongHop/ChiTietTongHop";

const RoutesIndex = ({ formRef }: any) => {
  const useInfo = useAppSelector(selectUser);
  const dataVaiTro = useInfo?.user?.vaiTros;
  const listVaiTroAll = dataVaiTro
    ? dataVaiTro.map((item: { item: any }) => item)
    : [];
  const listMaVaiTro = listVaiTroAll.map((item: any) => item.maVaiTro);
  return (
    <Routes>
      {/* Home */}
      <Route path="/home" element={<Home />} />
      {/* quyền */}
      <Route
        path="/quan-tri/quyen"
        element={<Quyen status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/quyen/them-moi"
        element={<QuyenForm status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/quyen/:id/chinh-sua"
        element={<QuyenForm status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      {/* chức vụ */}
      <Route
        path="/quan-tri/chuc-vu"
        element={<ChucVu status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/chuc-vu/them-moi"
        element={<ChucVuForm status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/chuc-vu/:id/chinh-sua"
        element={<ChucVuForm status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      {/* vai trò */}
      <Route
        path="/quan-tri/vai-tro"
        element={<VaiTro status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/vai-tro/them-moi"
        element={<VaiTroForm status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/vai-tro/:id/chinh-sua"
        element={<VaiTroForm status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      {/* phòng ban */}
      <Route
        path="/quan-tri/phong-ban"
        element={<PhongBan status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/phong-ban/them-moi"
        element={<PhongBanForm status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/phong-ban/:id/chinh-sua"
        element={<PhongBanForm status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      {/* phòng ban table */}
      <Route
        path="/quan-tri/phong-ban-table"
        element={<PhongBanTable status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/phong-ban-table/them-moi"
        element={
          <PhongBanTableForm status={checkAuth(["ADMIN"], listMaVaiTro)} />
        }
      />

      <Route
        path="/quan-tri/phong-ban-table/:id/chinh-sua"
        element={
          <PhongBanTableForm status={checkAuth(["ADMIN"], listMaVaiTro)} />
        }
      />

      <Route
        path="/quan-tri/nguoi-dung"
        element={<NguoiDung status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/nguoi-dung/them-moi"
        element={<NguoiDungForm status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/nguoi-dung/:id/chinh-sua"
        element={<NguoiDungForm status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      {/* không có quyền */}
      <Route path="/error/401" element={<Error401 />} />

      <Route path="/user/ho-so" element={<HoSo />} />

      {/* danh mục nhóm tư liệu */}
      <Route
        path="/quan-tri/nhom-tu-lieu"
        element={<NhomTaiLieu status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/nhom-tu-lieu/them-moi"
        element={
          <NhomTaiLieuForm status={checkAuth(["ADMIN"], listMaVaiTro)} />
        }
      />
      <Route
        path="/quan-tri/nhom-tu-lieu/:id/chinh-sua"
        element={
          <NhomTaiLieuForm status={checkAuth(["ADMIN"], listMaVaiTro)} />
        }
      />

      {/* danh mục loại tư liệu */}
      <Route
        path="/quan-tri/loai-tu-lieu"
        element={<LoaiTaiLieu status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/loai-tu-lieu/them-moi"
        element={
          <LoaiTaiLieuForm status={checkAuth(["ADMIN"], listMaVaiTro)} />
        }
      />
      <Route
        path="/quan-tri/loai-tu-lieu/:id/chinh-sua"
        element={
          <LoaiTaiLieuForm status={checkAuth(["ADMIN"], listMaVaiTro)} />
        }
      />

      {/* danh mục thời hạn lưu trữ */}
      <Route
        path="/quan-tri/thoi-han-luu-tru"
        element={<ThoiHanLuuTru status={checkAuth(["ADMIN"], listMaVaiTro)} />}
      />
      <Route
        path="/quan-tri/thoi-han-luu-tru/them-moi"
        element={
          <ThoiHanLuuTruForm status={checkAuth(["ADMIN"], listMaVaiTro)} />
        }
      />
      <Route
        path="/quan-tri/thoi-han-luu-tru/:id/chinh-sua"
        element={
          <ThoiHanLuuTruForm status={checkAuth(["ADMIN"], listMaVaiTro)} />
        }
      />

      {/* danh mục phân quyền người dùng */}
      <Route
        path="/quan-tri/phan-quyen-nguoi-dung"
        element={<PhanQuyenNguoiDung />}
      />
      <Route
        path="/quan-tri/phan-quyen-nguoi-dung/them-moi"
        element={<PhanQuyenNguoiDungForm />}
      />
      <Route
        path="/quan-tri/phan-quyen-nguoi-dung/:id/chinh-sua"
        element={<PhanQuyenNguoiDungForm />}
      />

      {/* danh sách video */}
      <Route
        path={`/video/idnhomtulieu/:idnhomtulieu`}
        element={
          <DanhSachVideo
            status={checkAuth(
              ["ADMIN", "SOAN_THAO", "DUYET_XUAT_BAN"],
              listMaVaiTro
            )}
            formRef={formRef}
          />
        }
      />
      <Route
        path={"/video/them-moi/idnhomtulieu/:idnhomtulieu"}
        element={
          <DanhSachVideoForm
            status={checkAuth(
              ["ADMIN", "SOAN_THAO", "DUYET_XUAT_BAN"],
              listMaVaiTro
            )}
          />
        }
      />
      <Route
        path={`/video/:videoid/chinh-sua/idnhomtulieu/:idnhomtulieu`}
        element={
          <DanhSachVideoForm
            status={checkAuth(
              ["ADMIN", "SOAN_THAO", "DUYET_XUAT_BAN"],
              listMaVaiTro
            )}
          />
        }
      />
      <Route
        path={`/video/:videoid/chi-tiet/idnhomtulieu/:idnhomtulieu`}
        element={<ThongTinVideoDetail />}
      />

      {/* danh sách hình ảnh */}
      <Route
        path={`/hinh-anh/idnhomtulieu/:idnhomtulieu`}
        element={
          <DanhSachHinhAnh
            status={checkAuth(
              ["ADMIN", "SOAN_THAO", "DUYET_XUAT_BAN"],
              listMaVaiTro
            )}
            formRef={formRef}
          />
        }
      />
      <Route
        path={"/hinh-anh/them-moi/idnhomtulieu/:idnhomtulieu"}
        element={
          <DanhSachHinhAnhForm
            status={checkAuth(
              ["ADMIN", "SOAN_THAO", "DUYET_XUAT_BAN"],
              listMaVaiTro
            )}
          />
        }
      />
      <Route
        path={`/hinh-anh/:hinhanhid/chinh-sua/idnhomtulieu/:idnhomtulieu`}
        element={
          <DanhSachHinhAnhForm
            status={checkAuth(
              ["ADMIN", "SOAN_THAO", "DUYET_XUAT_BAN"],
              listMaVaiTro
            )}
          />
        }
      />
      <Route
        path={`/hinh-anh/:hinhanhid/chi-tiet/idnhomtulieu/:idnhomtulieu`}
        element={<ThongTinHinhAnhDetail />}
      />

      {/* danh sách tư liệu */}
      <Route
        path={`/tu-lieu/idnhomtulieu/:idnhomtulieu`}
        element={
          <DanhSachTuLieu
            status={checkAuth(
              ["ADMIN", "SOAN_THAO", "DUYET_XUAT_BAN"],
              listMaVaiTro
            )}
            formRef={formRef}
          />
        }
      />
      <Route
        path={"/tu-lieu/them-moi/idnhomtulieu/:idnhomtulieu"}
        element={
          <DanhSachTuLieuForm
            status={checkAuth(
              ["ADMIN", "SOAN_THAO", "DUYET_XUAT_BAN"],
              listMaVaiTro
            )}
          />
        }
      />
      <Route
        path={`/tu-lieu/:tulieuid/chinh-sua/idnhomtulieu/:idnhomtulieu`}
        element={
          <DanhSachTuLieuForm
            status={checkAuth(
              ["ADMIN", "SOAN_THAO", "DUYET_XUAT_BAN"],
              listMaVaiTro
            )}
          />
        }
      />
      <Route
        path={`/tu-lieu/:tulieuid/chi-tiet/idnhomtulieu/:idnhomtulieu`}
        element={<ThongTinTuLieuDetail />}
      />

      {/* trả lời góp ý */}
      <Route
        path={`/quan-tri/tra-loi-gop-y`}
        element={<DanhSachGopY status={checkAuth(["ADMIN", "DUYET_XUAT_BAN"], listMaVaiTro)} />}
      />
      <Route
        path={`/quan-tri/:idgopy/tra-loi-gop-y/idtulieu/:idtulieu`}
        element={<TraLoiGopYForm status={checkAuth(["ADMIN", "DUYET_XUAT_BAN"], listMaVaiTro)} />}
      />

      {/* thống kê */}
      <Route
        path={`/thong-ke/theo-nguoi-nhap`}
        element={
          <ThongKeTheoNguoiNhap status={checkAuth(["ADMIN", "DUYET_XUAT_BAN", "SOAN_THAO"], listMaVaiTro)} />
        }
      />
      <Route
        path={`/thong-ke/chi-tiet/theo-nguoi-nhap/:idnguoidang`}
        element={
          <ChiTietTheoNguoiNhap status={checkAuth(["ADMIN", "DUYET_XUAT_BAN", "SOAN_THAO"], listMaVaiTro)} />
        }
      />
      <Route
        path={`/thong-ke/tong-hop-theo-nhom-tu-lieu`}
        element={<ThongKeTongHop status={checkAuth(["ADMIN", "DUYET_XUAT_BAN", "SOAN_THAO"], listMaVaiTro)} />}
      />
      <Route
        path={`/thong-ke/chi-tiet/tong-hop-theo-nhom-tu-lieu/:idnhomtulieu`}
        element={<ChiTietTongHop status={checkAuth(["ADMIN", "DUYET_XUAT_BAN", "SOAN_THAO"], listMaVaiTro)} />}
      />
    </Routes>
  );
};

export default RoutesIndex;
